(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["buy-buttons"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('quantite-rapide')) {
    customElements.define(
      'quantite-rapide',
      class extends HTMLElement {
        connectedCallback() {
          this.prix = parseInt(this.dataset.prix, 10) || 0;
          this.form = this.closest('form');
          this.boutons = Array.from(this.querySelectorAll('[data-quantite]'));
          this.boutons.forEach((b) =>
            b.addEventListener('click', () => this.choisir(parseInt(b.dataset.quantite, 10)))
          );
          this.surChangement = () => requestAnimationFrame(() => this.majAffichage());
          if (this.form) {
            this.form.addEventListener('input', this.surChangement);
            this.form.addEventListener('change', this.surChangement);
            this.form.addEventListener('click', this.surChangement);
          }
          this.majAffichage();
        }

        disconnectedCallback() {
          if (!this.form) return;
          this.form.removeEventListener('input', this.surChangement);
          this.form.removeEventListener('change', this.surChangement);
          this.form.removeEventListener('click', this.surChangement);
        }

        champ() {
          return this.form ? this.form.querySelector('input[name="quantity"]') : null;
        }

        choisir(n) {
          const champ = this.champ();
          if (!champ) return;
          const selecteur = champ.closest('quantity-selector-component');
          if (selecteur && typeof selecteur.setValue === 'function') {
            selecteur.setValue(String(n));
            if (typeof selecteur.updateButtonStates === 'function') selecteur.updateButtonStates();
          } else {
            champ.value = String(n);
          }
          champ.dispatchEvent(new Event('change', { bubbles: true }));
          this.majAffichage();
        }

        majAffichage() {
          const champ = this.champ();
          const n = champ ? parseInt(champ.value, 10) || 1 : 1;
          this.boutons.forEach((b) =>
            b.setAttribute('aria-pressed', String(parseInt(b.dataset.quantite, 10) === n))
          );
          const total = this.querySelector('[data-total]');
          if (total && this.prix) {
            const montant = ((this.prix * n) / 100).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' });
            total.textContent = n + (n > 1 ? ' stickers' : ' sticker') + ' = ' + montant;
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["note-avis"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('note-avis-trustpilot')) return;

    const CACHE_KEY = 'pns-trustpilot';
    const CACHE_MS = 30 * 60 * 1000;
    const requests = {};

    function getData(businessUnit) {
      try {
        const cached = JSON.parse(sessionStorage.getItem(CACHE_KEY + businessUnit) || 'null');
        if (cached && Date.now() - cached.t < CACHE_MS) return Promise.resolve(cached.d);
      } catch (e) {}

      if (!requests[businessUnit]) {
        const url =
          'https://widget.trustpilot.com/trustbox-data/56278e9abfbbba0bdcd568bc?businessUnitId=' +
          encodeURIComponent(businessUnit) +
          '&locale=fr-FR';
        requests[businessUnit] = fetch(url)
          .then((r) => (r.ok ? r.json() : Promise.reject(r.status)))
          .then((json) => {
            const bu = json.businessUnit || json.businessEntity;
            const d = { score: bu.trustScore, total: bu.numberOfReviews.total };
            if (typeof d.score !== 'number' || typeof d.total !== 'number') throw new Error('format');
            try {
              sessionStorage.setItem(CACHE_KEY + businessUnit, JSON.stringify({ t: Date.now(), d }));
            } catch (e) {}
            return d;
          });
      }
      return requests[businessUnit];
    }

    class NoteAvisTrustpilot extends HTMLElement {
      connectedCallback() {
        const businessUnit = this.dataset.businessUnit;
        if (!businessUnit) return;
        getData(businessUnit)
          .then((d) => this.render(d))
          .catch(() => {});
      }

      render({ score, total }) {
        const note = this.querySelector('[data-note]');
        const nombre = this.querySelector('[data-nombre]');
        if (note) note.textContent = score.toLocaleString('fr-FR', { minimumFractionDigits: 1, maximumFractionDigits: 1 });
        if (nombre) nombre.textContent = total.toLocaleString('fr-FR');

        const rounded = Math.round(score * 2) / 2;
        this.querySelectorAll('[data-etoile]').forEach((el) => {
          const i = Number(el.dataset.etoile);
          el.classList.toggle('note-avis__etoile--vide', i > Math.ceil(rounded));
          el.classList.toggle('note-avis__etoile--demi', i === Math.ceil(rounded) && rounded % 1 !== 0);
        });
      }
    }

    customElements.define('note-avis-trustpilot', NoteAvisTrustpilot);
  })();
  } catch(e) { console.error(e); }
})();

})();
